<template>
  <b-modal
    id="details-sales"
    no-enforce-focus
    title="Cadastro de Banner Sales"
    header-bg-variant="dark"
    header-close-variant="light"
    title-class="text-light font-18"
    hide-footer
    @show="resetForm"
    @hidden="resetForm"
  >
    <div v-if="!loading" class="grid-web">
      <b-col cols="12" style="display: flex; width: 100%; justify-content: center;">
        <div v-if="attachmentPreview" class="file-inner">
          <img style="border-radius: 5px; width: 100%;" :src="attachmentPreview" />
          <span style="cursor: pointer;" @click="removeImage">Remover Imagem</span>
        </div>
        <label v-if="!attachmentPreview" for="file-upload-sales" class="custom-file-upload">
          <div class="file-inner"></div>
          <img style="position: relative" class="pointer" src="../../../assets/images/paperclip.svg" />
          <h4 style="color: grey;">640 x 100</h4>
        </label>
        <input
          id="file-upload-sales"
          ref="fileUploadSales"
          accept="image/png, image/jpeg, image/jpg"
          type="file"
          @change="setFile"
        />
      </b-col>
      <div class="row">
        <div class="col-12">
          <b-form-input v-model="payload.link" placeholder="Link de redirecionamento"></b-form-input>
        </div>
        <div class="col-12 mt-2">
          <b-form-group
            label="Ordem de exibição"
            label-for="sales-banner-order"
            description="Ao escolher uma posição, os demais banners são reordenados automaticamente."
          >
            <b-form-select
              id="sales-banner-order"
              v-model="payload.order"
              :options="orderOptions"
            ></b-form-select>
          </b-form-group>
        </div>
        <div class="col-12 mt-3 pa-2">
          <b-button variant="success" :disabled="!canSave" @click="createBanner"> Salvar </b-button>
        </div>
      </div>
    </div>
    <div v-if="loading" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

const MAX_IMAGE_BYTES = 10 * 1024 * 1024

export default {
  data() {
    return {
      attachment: null,
      attachmentPreview: '',
      loading: false,
      payload: {
        link: '',
        order: null,
      },
    }
  },
  computed: {
    ...mapGetters({ salesBanners: 'getSalesBanners' }),
    orderOptions() {
      return Array.from({ length: this.salesBanners.length + 1 }, (value, index) => index + 1)
    },
    canSave() {
      return !!(this.attachment && this.payload.order != null)
    }
  },
  methods: {
    setFile(e) {
      const file = e.target.files[0]
      if (!file) return
      if (file.size > MAX_IMAGE_BYTES) {
        this.$bvToast.toast('A imagem deve ter no maximo 10MB.', {
          variant: 'danger',
          title: 'Imagem muito grande',
          autoHideDelay: 5000,
        })
        e.target.value = ''
        this.attachment = null
        this.attachmentPreview = ''
        return
      }
      this.attachment = file
      const reader = new FileReader()
      reader.onloadend = () => {
        this.attachmentPreview = reader.result
      }
      reader.readAsDataURL(file)
    },
    removeImage() {
      this.attachment = null
      this.attachmentPreview = ''
      if (this.$refs.fileUploadSales) {
        this.$refs.fileUploadSales.value = ''
      }
    },
    resetForm() {
      this.payload = { link: '', order: this.salesBanners.length + 1 }
      this.removeImage()
      this.loading = false
    },
    apiErrorMessage(err) {
      const apiError = err && err.response && err.response.data && err.response.data.error
      const message = apiError && typeof apiError === 'object' ? apiError.message : apiError

      return message || (err && err.message) || 'Não foi possível criar o banner.'
    },
    createBanner() {
      if (!this.attachment) {
        this.$bvToast.toast('Selecione uma imagem!', {
          variant: 'danger',
          title: 'Uma imagem é necessária!',
          autoHideDelay: 5000,
        })
        return
      }

      this.loading = true

      return this.$store.dispatch('createSalesBanner', {
        attachment: this.attachment,
        link: this.payload.link,
        order: this.payload.order,
      })
        .then(() => {
          this.$bvToast.toast('o banner foi criado com sucesso!', {
            variant: 'success',
            title: 'Banner criado!',
            autoHideDelay: 5000
          })
          this.$bvModal.hide('details-sales')
          this.resetForm()
        })
        .catch(err => {
          this.$bvToast.toast(this.apiErrorMessage(err), {
            variant: 'danger',
            title: 'Erro ao criar o banner!',
            autoHideDelay: 5000
          })
        })
        .finally(() => { this.loading = false })
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-web {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
}

input[type='file'] {
  display: none;
}

.file-inner {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.custom-file-upload {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 120px;
  min-width: 100%;
  background: #f7f7f7;
  border-radius: 5px;
  border: none;
  cursor: pointer;
}
</style>
